import React from 'react';
import { Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

const RadarChart = ({ scores }) => {
  const data = {
    labels: [
      'Cerebrum-Root\n(Attention/Inhibition)',
      'Cerebrum-Leaf\n(Self-Monitoring)',
      'Cerebrum-Flower\n(Planning)',
      'Limbic System\n(Emotion)',
      'Brainstem\n(Sensory)'
    ],
    datasets: [{
      label: 'Cognitive Profile',
      data: [
        scores.cerebrumRoot,
        scores.cerebrumLeaf,
        scores.cerebrumFlower,
        scores.limbicSystem,
        scores.brainstem
      ],
      backgroundColor: 'rgba(102, 2, 60, 0.2)', // brand-crimson
      borderColor: 'rgba(102, 2, 60, 1)',
      borderWidth: 3,
      pointBackgroundColor: 'rgba(102, 2, 60, 1)',
      pointBorderColor: '#fffaf0',
      pointBorderWidth: 2,
      pointRadius: 6,
      pointHoverRadius: 8
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      r: {
        angleLines: {
          display: true,
          color: 'rgba(61, 43, 31, 0.1)' // brand-coffee
        },
        grid: {
          color: 'rgba(61, 43, 31, 0.1)'
        },
        pointLabels: {
          font: {
            size: 12,
            weight: 'bold',
            family: "'Manrope', sans-serif"
          },
          color: '#3d2b1f'
        },
        suggestedMin: 0,
        suggestedMax: 4,
        ticks: {
          stepSize: 1,
          showLabelBackdrop: false,
          color: '#8a9a5b', // brand-palm
          callback: function(value) {
            if (value === 0) return 'Minimal';
            if (value === 1) return 'Mild';
            if (value === 2) return 'Moderate';
            if (value === 3) return 'Significant';
            if (value === 4) return 'Severe';
            return '';
          }
        }
      }
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const value = context.raw.toFixed(1);
            let level = '';
            if (value < 1.5) level = 'Minimal';
            else if (value < 2.5) level = 'Mild';
            else if (value < 3.5) level = 'Moderate';
            else level = 'Significant';
            return `Score: ${value}/4 (${level})`;
          }
        }
      }
    }
  };

  return (
    <div className="w-full h-96">
      <Radar data={data} options={options} />
    </div>
  );
};

export default RadarChart;